import PropTypes from "prop-types";

const AttemptReportTable = ({ attempts, onViewAttempt }) => {
  const formatDuration = (seconds) => {
    if (seconds === undefined || seconds === null) {
      return "00:00";
    }

    const minutes = Math.floor(seconds / 60);

    const remainingSeconds = seconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleViewAttempt = (id) => {
    if (onViewAttempt) {
      onViewAttempt(id);
    }
  };

  if (!attempts || attempts.length === 0) {
    return (
      <div className="bg-white rounded-lg border p-5 text-center text-gray-500">
        No attempts available for this quiz.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
      <div className="p-4 border-b">
        <h2 className="text-lg font-semibold text-gray-800">
          Quiz Attempt Report
        </h2>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Student
              </th>

              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Student ID
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Attempt
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Score
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Percentage
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Result
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Duration
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Date
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Action
              </th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {attempts.map((attempt) => (
              <tr key={attempt._id} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div>
                    <p className="text-sm font-medium text-gray-800">
                      {attempt.student?.name || "Unknown"}
                    </p>

                    <p className="text-xs text-gray-500">
                      {attempt.student?.phone || "-"}
                    </p>
                  </div>
                </td>

                <td className="px-4 py-3 text-sm text-gray-700">
                  {attempt.student?.studentId || "-"}
                </td>

                <td className="px-4 py-3 text-center text-sm text-gray-700">
                  #{attempt.attemptNumber ?? "-"}
                </td>

                <td className="px-4 py-3 text-center text-sm font-medium">
                  {attempt.obtainedMarks ?? 0}/{attempt.totalMarks ?? 0}
                </td>

                <td className="px-4 py-3 text-center text-sm text-gray-700">
                  {attempt.percentage ?? 0}%
                </td>

                <td className="px-4 py-3 text-center">
                  <span
                    className={`
                      px-3
                      py-1
                      rounded-full
                      text-xs
                      font-semibold

                      ${
                        attempt.result === "pass"
                          ? "bg-green-100 text-green-700"
                          : attempt.result === "fail"
                            ? "bg-red-100 text-red-700"
                            : "bg-gray-100 text-gray-700"
                      }
                    `}
                  >
                    {attempt.result ? attempt.result.toUpperCase() : "PENDING"}
                  </span>
                </td>

                <td className="px-4 py-3 text-center text-sm text-gray-700">
                  {formatDuration(attempt.durationSeconds)}
                </td>

                <td className="px-4 py-3 text-center text-sm text-gray-700">
                  {formatDate(attempt.createdAt)}
                </td>

                <td className="px-4 py-3 text-center">
                  <button
                    type="button"
                    onClick={() => handleViewAttempt(attempt._id)}
                    className="
                      text-blue-600
                      hover:text-blue-800
                      text-sm
                      font-medium
                    "
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

AttemptReportTable.propTypes = {
  attempts: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,

      attemptNumber: PropTypes.number,

      obtainedMarks: PropTypes.number,

      totalMarks: PropTypes.number,

      percentage: PropTypes.number,

      result: PropTypes.string,

      durationSeconds: PropTypes.number,

      createdAt: PropTypes.string,

      student: PropTypes.shape({
        name: PropTypes.string,

        phone: PropTypes.string,

        studentId: PropTypes.string,
      }),
    }),
  ),

  onViewAttempt: PropTypes.func,
};

AttemptReportTable.defaultProps = {
  attempts: [],

  onViewAttempt: undefined,
};

export default AttemptReportTable;
